var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-segment',[_c('h2',[_vm._v(_vm._s(_vm.$t('files.add')))]),_c('Upload',{on:{"onSuccess":_vm.handleFileUpload,"remove":_vm.handleFileRemove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }